// Global display corner settings (shop API global_display) as the CSS variables
// every radius in the portal reads: buttons use --button-corner-radius, every
// other element (cards, inputs, images, popovers…) --element-corner-radius.
// A missing / unknown setting sets nothing, so each rule keeps its own fallback.

// element_corners → px, same as trustshop-fe getCornerRadiusValue
const ELEMENT_CORNER_RADIUS = {
    square: 0,
    soft_corners: 4,
    rounded: 8,
    curved: 16,
};

const getCornerRadiusStyle = (globalDisplay) => {
    const style = {};
    const buttonRadius = globalDisplay?.button_corner_radius;
    if (buttonRadius !== null && buttonRadius !== "" && Number.isFinite(Number(buttonRadius))) {
        style["--button-corner-radius"] = `${Number(buttonRadius)}px`;
    }
    const elementRadius = ELEMENT_CORNER_RADIUS[globalDisplay?.element_corners];
    if (elementRadius !== undefined) {
        style["--element-corner-radius"] = `${elementRadius}px`;
    }
    return style;
};

export default getCornerRadiusStyle;
